<template>
  <div>
    <Card shadow :padding="15">
      <Row type="flex" align="middle">
        <i-col :span="24">
          <div @click="routeUrl">
            <Row type="flex" align="middle">
              <i-col :span="3" style="text-align:center">
                <Icon :type="icon" size="35"></Icon></i-col>
              <i-col :span="19">
                <p class="section-header">{{title}}</p>
                <span class="section-label">{{info}}</span>
              </i-col>
              <i-col :span="2"><Icon :type="'chevron-right'" style=""></Icon></i-col>
            </Row>
          </div>
        </i-col>
          <!-- <i-col :span="24">
            <div style="height:auto;overflow:hidden">
              <transition
                  mode="out-in"
                  enter-active-class="animated slideInDown faster"
                  leave-active-class="animated slideOutUp faster">
                <div v-show="isShow">
                    <DocumentsComponent></DocumentsComponent>
                </div>
              </transition>
            </div>
          </i-col> -->
      </Row>
    </Card>
  </div>
</template>

<script>
import FieldItemPassword from '@/views/UserProfileSettingPasswordFieldItemComponent'
import FeedList from "@/components/FeedListComponent";
import DocumentsComponent from "@/components/DocumentsComponent"

export default {
  components: {
    FieldItemPassword,FeedList,DocumentsComponent
  },
  props: {
    tag: {
      type: String
    },
    icon: {
      type: String
    },
    title: {
      type: String
    },
    info: {
      type: String
    }
  },
  data() {
    return {
      collapse: false,
      oldPasswordField: {
        "label": "Old Password",
        "type": "password",
        "slug": "old_password"
      },
      newPasswordField: {
        "label": "New Password",
        "type": "password",
        "slug": "new_password"
      },
      confirmPasswordField: {
        "label": "Confirm Password",
        "type": "password",
        "slug": "confirm_password"
      },
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    }
  },
  created() {
    BroadcastEvent.$on('PASSWORDCHANGED', () => {
      this.oldPassword = ""
      this.newPassword = ""
      this.confirmPassword = ""
    })
  },
  methods: {
    onChange(v) {
      if(this.oldPassword && this.newPassword && this.newPassword.length >= 8 && (this.newPassword === this.confirmPassword)) {
        BroadcastEvent.$emit('ONPASSWORDCHANGE', 
          { "success": true,
            "oldPassword": this.oldPassword,
            "newPassword": this.newPassword,
          })
      } else {
        BroadcastEvent.$emit('ONPASSWORDCHANGE', 
          { "success": false,
            "oldPassword": this.oldPassword,
            "newPassword": this.newPassword,
          })
      } 
    },
    routeUrl() {
      this.$router.push({ path: '/documents/'})
    }
  },
  computed: {
    isShow: {
      get() { return this.collapse },
      set(v) { this.collapse = v }
    },
    lessCharacter() {
      if(this.newPassword)
        return this.newPassword.length < 8
      return false
    },
    passwordNotTheSame() {
      if(this.newPassword && this.confirmPassword) {
        return this.newPassword !== this.confirmPassword
      }
      return false
    },
  },
}
</script>

<style scoped>
  .add-margin {
    margin-bottom:5px;
  }
  .section-header {
    font-weight: 700;
    color:#333;
  }
  .section-label {
    font-size:11px;
    line-height: 20px;
    color:#aaa;
  }
  .section-value {
    min-height: 20px;
    display: block;
  }
  .m {
    color: #333
  }
</style>
